import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import ProductContext from '@/product/context/product/productContext'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CustomDialog from '@/product/components/organisms/Dialog'
import CommentContext from '@/product/context/comment/commentContext'

const ReplyComments = (props) => {
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        all_reply_comments,
        getAllReplyComments,
        responseStatus: replyCommentsResponse,
    } = useContext(CommentContext)

    const history = useHistory()
    const { setAlert } = alertContext

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            id: 0,
            filters: {
                comment_id: {
                    value: 0,
                    type: 'in',
                    field: 'c.comment_id',
                },
                status: {
                    value: 1,
                    type: 'in',
                    field: 'c.active',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllReplyComments(values, 'reply_comments')
        },
    })

    useEffect(() => {
        if (
            replyCommentsResponse?.from === 'saveComment' &&
            replyCommentsResponse?.status === 'success'
        ) {
            if (formik.values.id) {
                getAllReplyComments(formik.values, 'reply_comments')
            }
        }
    }, [replyCommentsResponse])

    useEffect(() => {
        if (all_reply_comments && all_reply_comments.from == 'reply_comments') {
            setTableBody(
                all_reply_comments.records.length
                    ? all_reply_comments.records
                    : []
            )
        }
        setIsLoading(false)
    }, [all_reply_comments])

    const resetFrom = () => {
        formik.setValues({
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            project_id: 0,
            filters: {
                comment_id: {
                    value: 0,
                    type: 'in',
                    field: 'c.comment_id',
                },
                status: {
                    value: 1,
                    type: 'in',
                    field: 'c.active',
                },
            },
        })
        formik.handleReset()
        setIsLoading(false)
    }

    useEffect(() => {
        if (data.status === 'answer') {
            setTableBody([])
            setIsLoading(true)
            formik.values.page = 1
            formik.values.id = props.data.id
            formik.values.filters.comment_id.value = props.data.id
            getAllReplyComments(formik.values, 'reply_comments')
        } else {
            resetFrom()
        }
    }, [data.id])

    const tableValues = [
        {
            field: 'comment',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Answers',
        },
        {
            field: 'first_name',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'First Name',
        },
        {
            field: 'last_name',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Last Name',
        },
        // {
        //     field: 'email',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Email',
        // },
    ]

    return (
        <FullScreenPopup
            modaltitle={`Answers History`}
            open={data.status === 'answer' ? data.popup : false}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={all_reply_comments}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getAllReplyComments}
                        hideCompactView={true}
                        columnStorageVariable={'table_reply_comments'}
                    />
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default ReplyComments
